import { MediaModel } from './media.model';

export class MetaModel {
  Title?: string;
  Description?: string;
  Url: string = '';
  Image: MediaModel = new MediaModel();
  Type: number = 0;
}
